import { doc } from "firebase/firestore";
import { db } from "@poseidon/firebase/firebase";
import config from "@poseidon/utils/config";
import { useEffect, useState } from "react";
import { useDocument } from "react-firebase-hooks/firestore";
import { creditUnderwritingSchema } from "../schema";

export const useCreditUnderwriting = (applicationId) => {
  const [creditUnderwriting, setCreditUnderwriting] = useState();
  const [value, loading, error] = useDocument(
    doc(
      db,
      "applications",
      applicationId,
      config.SaltCollection.Application_CreditUnderwriting,
      config.SaltCollection._current
    ),
    {
      snapshotListenOptions: { includeMetadataChanges: true },
    }
  );
  useEffect(() => {
    if (value) {
      const creditUnderwriting = mapCreditUnderwriting(value);
      setCreditUnderwriting(creditUnderwriting);
    }
  }, [value, applicationId]);

  return { creditUnderwriting, loading, error };
};

const mapCreditUnderwriting = (docRef) => {
  if (!docRef.exists()) {
    return {};
  }

  let creditUnderwriting = creditUnderwritingSchema.cast(docRef.data());
  creditUnderwriting.id = docRef.id;

  return creditUnderwriting;
};
